import React, { useState } from "react";
import { useFormContext } from "react-hook-form";
import { Button, Divider, Form, Icon } from "semantic-ui-react";
import { ControlledInput } from "./ControlledForm";
import { OAuthIDP } from "../hooks/useOAuth";
import useProducts from "./admin/employees/hooks/useProducts";

interface IRegisterFormProps {
  onSubmit: (data: any) => void;
  initiateOAuth?: (idp: OAuthIDP) => void;
}

export const RegisterForm = ({ onSubmit, initiateOAuth }: IRegisterFormProps) => {
  const { control, handleSubmit, formState, errors } = useFormContext();
  const { isValid } = formState;
  const { hasSSOMicrosoft } = useProducts();
  const [hidePassword, setHidePassword] = useState(true);
  const renderIcon = () => (
    <Icon
      name={hidePassword ? "eye slash" : "eye"}
      link
      onClick={() => setHidePassword(!hidePassword)}
      aria-label={hidePassword ? "Show password" : "Hide password"}
      title={hidePassword ? "Show password" : "Hide password"}
    />
  );

  return (
    <Form onSubmit={handleSubmit(onSubmit)} error={!isValid}>
      <Form.Group widths='equal'>
        <Form.Field required>
          <label htmlFor='firstName'>First Name</label>
          <ControlledInput name='firstName' autoComplete='given-name' control={control} errors={errors} />
        </Form.Field>
        <Form.Field required>
          <label htmlFor='lastName'>Last Name</label>
          <ControlledInput name='lastName' autoComplete='family-name' control={control} errors={errors} />
        </Form.Field>
      </Form.Group>
      <Form.Field required>
        <label htmlFor='email'>Email Address</label>
        <ControlledInput name='email' autoComplete='email' control={control} errors={errors} />
      </Form.Field>
      <Form.Field required>
        <label htmlFor='password'>Password</label>
        <ControlledInput
          type={hidePassword ? "password" : "text"}
          name='password'
          placeholder='Must be at least 8 characters'
          autoComplete='new-password'
          icon={renderIcon()}
          iconPosition='right'
          control={control}
          errors={errors}
        />
      </Form.Field>
      <Button style={{ margin: "24px 4px" }} className='permitsButton' type='submit' fluid primary size='large'>
        Create Account
      </Button>
      {initiateOAuth && hasSSOMicrosoft && <Divider horizontal>Or</Divider>}
      {initiateOAuth && hasSSOMicrosoft && (
        <Button
          className='tw-flex tw-items-center tw-justify-center tw-rounded-none tw-border-[1px] 
                    tw-border-solid tw-border-[#8C8C8C] tw-bg-white tw-p-3 tw-font-medium tw-text-[#5E5E5E]'
          type='button'
          fluid
          primary
          size='large'
          onClick={() => initiateOAuth?.(OAuthIDP.Microsoft)}
        >
          <img className='tw-mx-3' src='/assets/integrations/Microsoft Logo.svg' alt='Microsoft Logo' />
          Sign up with Microsoft
        </Button>
      )}
    </Form>
  );
};

export default RegisterForm;
